/** A jump destination: which step, and the `data-focus` element to highlight
 * once there. Every Sign-off cell and card carries one — the review page shows
 * what was picked and sends you back to the step that picked it. */
export interface FocusTarget {
  step: number;
  field: string;
}

/** Why a greyed (non-editable) review cell can't be edited from the grid, shown
 * as its tooltip. UNITS is fixed by the G-code; CONTROLLERS follows where each
 * G-code file is placed. */
export const READONLY_REASON: Record<string, string> = {
  UNITS: "Read from your G-code — can't be edited",
  CONTROLLERS: 'Set by where each G-code file is placed on Add files',
};
